import { Stack, Skeleton, Separator } from "@chakra-ui/react";

const Chunk = ({ width = "100%", height = "18px" }) => <Skeleton height={height} width={width} borderRadius="md" />;

export const GeneralInfoSkeleton = () => (
    <Stack gap={6}>
        {/* Claims Information */}
        <Stack gap={3}>
            <Chunk width="130px" height="16px" />
            <Chunk width="90%" height="16px" />
            <Chunk width="120px" height="16px" />
            <Chunk width="85%" height="16px" />
        </Stack>

        <Separator />

        {/* Bank Account Select */}
        <Stack gap={3}>
            <Chunk width="140px" height="16px" />
            <Chunk width="100%" height="40px" />
        </Stack>
    </Stack>
);
